import { FunctionalComponent, h } from "@stencil/core";

interface FetcherProps {
  status: string;
}

export const Fetcher: FunctionalComponent<FetcherProps> = (props, children) => {
  const {
    status
  } = props;

  if (status === 'loading') {
    return <div class="hr-loader">Happy React is loading...</div>;
  }

  if (status === 'error') {
    return <div class="hr-error">
      Something went wrong while loading.
    </div>
  }

  if (status === 'success') {
    return children;
  }

  return null;
}
